import React from "react";
import { withStyles } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import Container from '@material-ui/core/Container';
import * as moment from 'moment';
import PropTypes from "prop-types";
import * as i18n from "../common/i18n";

const styles = theme => ({
});

class DateTimeDialog extends React.Component {

    state = {
        time: moment().add(10, "m").format('YYYY-MM-DDTHH:mm'),
        disabled: false
    }

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <Dialog
                    maxWidth={"md"}
                    open={this.props.open}
                >
                    <DialogTitle>{this.props.dialogTitle}</DialogTitle>
                    <DialogContent>
                        <Container maxWidth="lg">
                            <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={"de"}>

                                <DateTimePicker
                                    label={this.props.dialogLabel}
                                    inputVariant="outlined"
                                    value={this.state.time}
                                    ampm={false}
                                    cancelLabel={this.props.cancelText}
                                    okLabel={this.props.confirmText}
                                    showTodayButton={true}
                                    format={"DD.MM.YYYY HH:mm [Uhr]"}
                                    todayLabel={this.props.todayLabel}
                                    disablePast={true}
                                    strictCompareDates={true}
                                    minDate={moment().add(1, "minutes").format('YYYY-MM-DDTHH:mm')}
                                    minDateMessage={i18n.get("dateTimePicker.minDateMessage")}
                                    onChange={(date) => { this.setState({ time: date }) }}
                                    onAccept={(date) => { this.setState({ disabled: date.isBefore(moment().add(1, "minutes")) ? true : false }) }}
                                />
                            </MuiPickersUtilsProvider>
                        </Container>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={this.props.onCancel} color="primary">
                            {this.props.cancelText}
                        </Button>
                        {this.state.disabled ?
                            <Button color="primary" disabled>
                                {this.props.confirmText}
                            </Button>
                            :
                            <Button onClick={() => this.props.onConfirm(this.state.time)} color="primary">
                                {this.props.confirmText}
                            </Button>
                        }
                    </DialogActions>

                </Dialog>
            </div>
        );
    }
}

DateTimeDialog.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(DateTimeDialog)